import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import i18n from "./i18n";
import VueMeta from "vue-meta";
import VueGtag from "vue-gtag";
import VueSocialSharing from "vue-social-sharing";

Vue.use(VueSocialSharing);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

// Configuration VueGtag
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GA_TRACKING_ID },
    enabled: false,
  },
  router
);

Vue.config.productionTip = false;

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
